export default {
  page: "Search"
};
